import React, { useCallback, useEffect, useState } from 'react';

import { jDatasourceExcel } from 'jamespot-user-api';

import {
    CSSItem,
    CSSItemLabel,
    CSSItemLabelWithEllipsis,
    CSSItemWrapper,
} from '../../JRCWidgetDatasourceTableEditor.styles';
import { JRCFileAvatar } from 'components/JRCFile/JRCFileAvatar';
import { JRCIconButton } from 'components/JRCIconButton/JRCIconButton';
import { Typography } from 'components/JRCTypography/JRCTypography.styles';
import { useIntl } from 'react-intl';

import { useEditorContext } from 'components/Widgets/context/hooks';
import { WidgetExcelDatasourceContext } from '../../JRCWidgetExcelDatasourceTableEditor';

export const ExcelEditorObject = ({ uri, onHandleCancel }: { uri: string; onHandleCancel: () => void }) => {
    const intl = useIntl();
    const [datasource, setDatasource] = useState<jDatasourceExcel | undefined>(undefined);

    const { hook, handlers, onChange, onError } = useEditorContext<WidgetExcelDatasourceContext>();

    const handleCancel = useCallback(() => {
        handlers.handleStart();
        handlers.jamespot.datasource
            .cancel(uri)
            .then(() => {
                onChange({ uri: undefined });
                onHandleCancel();
            })
            .catch(handlers.handleCatch)
            .finally(handlers.handleFinally);
    }, [uri, handlers, onChange, onHandleCancel]);

    useEffect(() => {
        if (!datasource && uri) {
            handlers.handleStart();
            handlers.jamespot.datasource
                .getExcelDatasource(uri)
                .then((response) => {
                    setDatasource(response.result);
                })
                .catch((err) => {
                    handlers.handleCatch(err);
                    onHandleCancel();
                })
                .finally(handlers.handleFinally);
        }
    }, [uri, datasource, onError, onHandleCancel, handlers]);

    return datasource ? (
        <>
            <Typography size={'l'}>{intl.formatMessage({ id: 'WIDGET_Datasource_Object' })}</Typography>
            <CSSItemWrapper>
                <CSSItem>
                    <JRCFileAvatar uri={datasource.file.uri} size={40} mimetype={datasource.file.mimetype} />
                    <CSSItemLabel>
                        <CSSItemLabelWithEllipsis>{datasource.file.title}</CSSItemLabelWithEllipsis>
                    </CSSItemLabel>
                    {hook && hook.isActive('WeDocHook') ? (
                        <JRCIconButton
                            tooltip={{
                                description: intl.formatMessage({ id: 'WIDGET_Excel_Datasource_Online_Edit' }),
                                position: 'left',
                            }}
                            icon="icon-eye"
                            color={'grey2'}
                            onClick={() => window.open(datasource.fileUrl, '_blank')}
                        />
                    ) : (
                        <JRCIconButton
                            tooltip={{
                                description: intl.formatMessage({ id: 'WIDGET_Excel_Datasource_Download' }),
                                position: 'left',
                            }}
                            icon="icon-download"
                            color={'grey2'}
                            onClick={() => window.open(`/downloadFile.php?id=${datasource.file.id}`, '_blank')}
                        />
                    )}
                    <JRCIconButton icon="icon-trash" color="orange" onClick={handleCancel} />
                </CSSItem>
            </CSSItemWrapper>
        </>
    ) : (
        <></>
    );
};
